// src/pages/DigitalMarketingPage.jsx
import React, { useEffect, useState } from "react";
import NavBar from "../components/NavBar";

const MatrixBackground = () => {
  useEffect(() => {
    const canvas = document.getElementById("matrix-dm-bg");
    const context = canvas.getContext("2d");

    let width = window.innerWidth;
    let height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;

    const katakana = "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン";
    const latin = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const nums = "0123456789";
    const alphabet = katakana + latin + nums;
    const fontSize = 16;
    const columns = width / fontSize;
    const rainDrops = new Array(Math.floor(columns)).fill(1);

    const draw = () => {
      context.fillStyle = "rgba(0, 0, 0, 0.05)";
      context.fillRect(0, 0, width, height);
      context.fillStyle = "#0F0";
      context.font = fontSize + "px monospace";

      for (let i = 0; i < rainDrops.length; i++) {
        const text = alphabet.charAt(Math.floor(Math.random() * alphabet.length));
        context.fillText(text, i * fontSize, rainDrops[i] * fontSize);
        if (rainDrops[i] * fontSize > height && Math.random() > 0.975) {
          rainDrops[i] = 0;
        }
        rainDrops[i]++;
      }
    };

    const interval = setInterval(draw, 30);
    const handleResize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    window.addEventListener("resize", handleResize);
    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <canvas
      id="matrix-dm-bg"
      className="fixed top-0 left-0 w-full h-full opacity-20 pointer-events-none"
    />
  );
};

const DigitalMarketingPage = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen bg-gray-900 text-white overflow-hidden">
      <NavBar />
      <MatrixBackground />
      <div className="relative z-10 container mx-auto px-4 py-16">
        {/* Header */}
        <header
          className={`text-center mb-12 transition-all duration-700 ${
            visible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
        >
          <h1 className="text-5xl font-bold font-mono text-green-500 mb-4">
            Digital Marketing
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            At AIOrbis, our Digital Marketing services are designed to elevate your online presence. We blend creative strategy with data-driven insights to craft campaigns that captivate and convert.
          </p>
        </header>

        {/* Approach */}
        <section className="mb-16">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-8 text-center">
            Our Approach
          </h2>
          <p className="text-gray-300 text-center">
            We integrate SEO, content marketing, social media, and PPC advertising into unified strategies that deliver measurable results.
          </p>
        </section>

        {/* Process */}
        <section className="mb-16">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-8 text-center">
            Our Process
          </h2>
          <div className="max-w-4xl mx-auto border-l-2 border-green-500 pl-6">
            <div className="relative mb-10 pl-4">
              <div className="absolute -left-2 top-0 w-4 h-4 bg-green-500 rounded-full border-2 border-gray-900"></div>
              <h3 className="font-mono font-bold text-xl text-green-400">
                Market Research
              </h3>
              <p className="text-gray-300 mt-2">
                We conduct comprehensive research to understand your target audience and competitive landscape.
              </p>
            </div>
            <div className="relative mb-10 pl-4">
              <div className="absolute -left-2 top-0 w-4 h-4 bg-green-500 rounded-full border-2 border-gray-900"></div>
              <h3 className="font-mono font-bold text-xl text-green-400">
                Campaign Development
              </h3>
              <p className="text-gray-300 mt-2">
                Our creative team develops innovative campaigns that resonate with your audience.
              </p>
            </div>
            <div className="relative mb-10 pl-4">
              <div className="absolute -left-2 top-0 w-4 h-4 bg-green-500 rounded-full border-2 border-gray-900"></div>
              <h3 className="font-mono font-bold text-xl text-green-400">
                Execution & Monitoring
              </h3>
              <p className="text-gray-300 mt-2">
                We execute campaigns with precision and continuously monitor performance to optimize results.
              </p>
            </div>
          </div>
        </section>

        {/* Call-to-Action */}
        <section className="text-center">
          <h2 className="text-3xl font-mono font-bold text-green-400 mb-4">
            Elevate Your Brand
          </h2>
          <p className="text-gray-300 mb-8">
            Let AIOrbis transform your digital presence with innovative marketing strategies.
          </p>
          <a
            href="/contact"
            className="px-8 py-3 bg-green-600 hover:bg-green-500 text-white font-mono rounded-lg transition-colors duration-300"
          >
            Get in Touch
          </a>
        </section>
      </div>
    </section>
  );
};

export default DigitalMarketingPage;
